import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    this.ariaDisabled();
    this.htmlScroll();
  }

  ariaDisabled() {
    const DIS = "[aria-disabled='true']";
    $(document).on("click", DIS, function (e) {
      e.preventDefault();
      e.stopPropagation();
      return;
    });
  }

  htmlScroll() {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }
}
